module.exports = __webpack_public_path__ + "img/h-page4-10.cb1edd5a.png";